import { infoIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Info = createIcon({
  displayName: 'Info',
  paths: [
    'M576 725.333h-54.571c-40.533 0-73.429-32.896-73.429-73.429 0-7.851 1.28-15.744 3.755-23.211l38.912-116.693h-42.667c-23.595 0-42.667-19.072-42.667-42.667s19.072-42.667 42.667-42.667h54.571c40.533 0 73.429 32.896 73.429 73.429 0 7.851-1.28 15.744-3.755 23.211l-38.912 116.693h42.667c23.595 0 42.667 19.072 42.667 42.667s-19.072 42.667-42.667 42.667zM512 256c23.595 0 42.667 19.072 42.667 42.667s-19.072 42.667-42.667 42.667c-23.595 0-42.667-19.072-42.667-42.667s19.072-42.667 42.667-42.667zM512 170.667c-188.203 0-341.333 153.131-341.333 341.333s153.131 341.333 341.333 341.333c188.203 0 341.333-153.131 341.333-341.333s-153.131-341.333-341.333-341.333z'
  ],
  canvasPaths: canvasIconPaths(infoIcon)
})
